import { AppRouteProps } from "@bsm/component";
import React from "react";

const TeacherCreateContainer = React.lazy(() => import("./containers/TeacherCreateContainer"));

export const TeacherCreateRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        element: <TeacherCreateContainer />,
    }   
]